<template>
	<div>
		<div v-if="!dialogVisible">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资发放汇总表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row style="padding-left: 46px; padding-top: 40px;">

						<el-col :span="7">
							<span>组织架构</span>
							<el-cascader v-model="condition.organize_ids" collapse-tags style="margin-left:10px;width:300px"
							:props="props" clearable></el-cascader>
						</el-col>

						<el-col :span="6">
							<span>日期</span>
							<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
								value-format="yyyy-MM" style="margin-left: 10px;">
							</el-date-picker>
						</el-col>

						<el-col :span="5">
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="Find">
								查询</el-button>
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="examine(null)">
								代发</el-button>
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="grant(null)">
								发放</el-button>
						</el-col>

						<el-col :span="2">
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="openfileUrl()">导入</el-button>
						</el-col>
						<el-dialog title="导入" :visible.sync="dialogVisibledr" width="30%"
							@close='closeDialog' :before-close="handleClose">
							<el-upload class="upload-demo" ref="adModel"
								:action="$globals.http + '/file/upload'" multiple
								:file-list="fileList" :on-success="handleAvatarSuccess"
								:on-remove="handleRemove">
								<el-button
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									选择文件</el-button>
							</el-upload>
							<div style="margin-top: 30px;">
								<div style="font-size: 18px;" v-if="fileDatatitle">导入失败项目名单：
								</div>
								<div
									style="display: flex; justify-content: flex-start;flex-wrap: wrap;">
									<div v-for="(item,index) in fileData"
										style="flex:1; width: calc((100% - 20px) / 5);min-width: calc((100% - 20px) / 5);max-width: calc((100% - 20px) / 5);">
										<div>{{item}}</div>
									</div>
								</div>
							</div>
							<el-button type="primary"
								style=" background-color: #006E4B; border: 1px solid #006E4B;margin: 30px 0 0 40%;"
								@click="savefileUrl()">确 定</el-button>
						</el-dialog>

						<el-col :span="4">
							
							<download-excel class="export-excel-wrapper"
								:fields="download_excel" title="工资发放汇总表"
									name="工资发放汇总表.xls"
								:fetch="ExportForm" >
								<el-button
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
							
						</el-col>
					</el-row>

					<el-row style="margin: 10px 2%; margin-top: 20px;">
						<el-row style="margin-top: 20px;">
							<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" :border="true"
								:row-class-name="tableRowClassName" ref="table" :data="tableData"
								:show-summary="showSum" :summary-method="getSummaries" height="530"
								tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange"
								@select-all="handleSelectAll" @select="handleSelect" @click="select"
								:expand-row-keys="expands">

								<el-table-column type="expand">
									<template slot-scope="scope">
										<el-table :header-cell-style="{ background: '#edeff1', color: '#000000' }"
											:border="true" ref="table" :data="scope.row.detailsList" height="400"
											tooltip-effect="dark" style="width: 100%;"
											@selection-change="handleSelectionChanges" @select="handleSelects"
											v-show="scope.row.detailsList.length > 0">
											<el-table-column type="selection" align="center" width="55">
											</el-table-column>
											<el-table-column align="center" label="序号" width="50">
												<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
											</el-table-column>
											<el-table-column prop="staff_name" align="center" label="员工姓名" width="100">
											</el-table-column>
											<el-table-column prop="after_tax_paid_salary" align="center"
												label="实发工资(税后)" width="120"></el-table-column>
											<el-table-column prop="receiving_method" align="center" label="领取方式"
												width="80"></el-table-column>
											<el-table-column prop="bank_card_number" align="center" label="银行卡号"
												width="150"></el-table-column>
											<el-table-column prop="cardholder_name" align="center" label="持卡人姓名"
												width="100"></el-table-column>
											<el-table-column prop="entry_name" align="center" label="项目名称" width="200">
											</el-table-column>
											<el-table-column prop="id_card" align="center" label="身份证号" width="170">
											</el-table-column>
											<el-table-column prop="telephone_number" align="center" label="电话号"
												width="110"></el-table-column>
											<el-table-column prop="gender" align="center" label="性别" width="60">
											</el-table-column>
											<el-table-column prop="post_name" align="center" label="岗位名称" width="130">
											</el-table-column>
											<el-table-column align="center" label="状态" width="120">
												<template slot-scope="scope">
													<img src="../../../assets/未发放.png"
														v-show="scope.row.spare5 === '0'" />
													<img src="../../../assets/待接收.png"
														v-show="scope.row.spare5 === '1'" />
													<img src="../../../assets/待发放.png"
														v-show="scope.row.spare5 === '2'" />
													<img src="../../../assets/已拆分.png"
														v-show="scope.row.spare5 === '3'" />
													<img src="../../../assets/发放成功.png"
														v-show="scope.row.spare5 === '4'" />
													<img src="../../../assets/发放失败.png"
														v-show="scope.row.spare5 === '5'" />
													<img src="../../../assets/已代发.png"
														v-show="scope.row.spare5 === '6'" />
													<img src="../../../assets/已代发.png"
														v-show="scope.row.spare5 === '7'" />
												</template>
											</el-table-column>
											<!-- <el-table-column align="center" label="操作" width="120">
												<template slot-scope="scope">

												</template>
											</el-table-column> -->
										</el-table>
									</template>
								</el-table-column>
								<el-table-column type="selection" align="center" width="55">
								</el-table-column>
								<el-table-column align="center" label="序号" width="50">
									<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
								</el-table-column>
								<!-- <el-table-column prop="years_date" align="center" label="日期"></el-table-column> -->
								<el-table-column prop="release_date" align="center" label="发放日期">
								</el-table-column>
								<el-table-column prop="superior_name" align="center" label="架构" width="300">
								</el-table-column>
								<el-table-column prop="organize_name" align="center" label="项目名称" width="300">
								</el-table-column>
								<el-table-column prop="reviewer_date" align="center" label="工资归属月" width="100">
								</el-table-column>
								<el-table-column prop="paid_amount" align="center" label="实发金额" width="120">
								</el-table-column>
								<el-table-column prop="cash" align="center" label="现金" width="120">
								</el-table-column>
								<el-table-column prop="bank_card" align="center" label="银行卡" width="100">
								</el-table-column>
								<el-table-column prop="reviewer_name" align="center" label="薪酬制作人" width="100">
								</el-table-column>
								<el-table-column prop="agency_company" align="center" label="代发公司" width="200">
								</el-table-column>
								<el-table-column prop="name_party_B" align="center" label="乙方名头" width="150">
								</el-table-column>
								<!-- <el-table-column align="center" label="状态" width="100">
									<template slot-scope="scope">
										<img src="../../../assets/待审批.png" v-show="scope.row.state === '0'" />
										<img src="../../../assets/已同意.png" v-show="scope.row.state === '1'" />
									</template>
								</el-table-column> -->
							</el-table>
						</el-row>
						<el-row style="margin-top: 30px; text-align: center;">
							<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
								layout=" prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-row>
					</el-row>

				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	components: {},
	data() {
		var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
		return {
			//列表相关
			page_num: 1,
			page_size: 10,
			total: 0,
			tableData: [],
			//复选框ids
			ids: [],
			idsson: [],
			//页面相关
			dialogVisible: false,
			fileData: [],
			dialogVisibledr: false,
			fileDatatitle: false,

			//职位下拉
			postList: [],

			//级联下拉配置
			props: {
				lazy: true,
				async lazyLoad(node, resolve) {
					if (node.level === 0) {
						return resolve(await organizeFind('', 'group'));
					} else {
						resolve(await organizeFind(node.data.id, ''));
					}
				},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: true,
			},
			//组织架构数据
			organizeList: [],

			//条件
			condition: {
				organize_ids: [],
				years_date: this.$globals.getNowTimes(),
			},

			//详情
			from: {

			},

			download_excel: {
				"项目名称": "organize_name",
				"工资归属月": "reviewer_date",
				"发放日期": "issue_date",
				"实发金额": "paid_amount",
				"现金": "cash",
				"银行卡": "bank_card",
				"薪酬制作人": "reviewer_name",
				"代发公司": "agency_company",
				"乙方名头": "name_party_B",
				
			},

			showSum: true,
			sums: ['合计', '', '', '', '', '0', '0', '0', '', '', ''],
			sum: 0,
		};
	},
	updated() {
		this.$nextTick(() => {
			this.$refs.table.doLayout()
		})
	},
	methods: {
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			// this.paid_amount_sum = 0;
			// selection.map(item => (item.paid_amount))
			e.forEach(item => {
				this.ids.push(item.organize_id);
			});
			// this.sums[5] = this.paid_amount_sum;
			// this.showSum = false;
			// this.$nextTick()
			// 	.then(() => {
			// 		this.showSum = true;
			// 	})
		},
		openfileUrl() {
			this.dialogVisibledr = true;
			this.fileurl = "";
			this.fileDatatitle = false;
			this.fileData = [];
		},
		closeDialog() {
			this.$refs.adModel.clearFiles()
		},
		handleAvatarSuccess(res, file) {
			this.fileurl = res.data.fileUrl;
		},

		handleSelectionChanges(a) {
			this.idsson = [];
			a.forEach(item => {
				this.idsson.push(item.id);
			});
		},

		handleSelect(list, item) {
			if (list.includes(item)) {
				//勾选时做的事
				this.sum = (item.paid_amount * 1000 + this.sum * 1000) / 1000;
			} else {
				//取消勾选时做的事，arguments[1]是当前取消勾选的项
				this.sum = (item.paid_amount * 1000 * -1 + this.sum * 1000) / 1000;
			}

			this.sums[5] = this.sum;
			this.showSum = false;
			this.$nextTick()
				.then(() => {
					this.showSum = true;
				})
		},

		handleSelects(list, item) {
			if (list.includes(item)) {
				//勾选时做的事
				this.sum = (item.after_tax_paid_salary * 1000 + this.sum * 1000) / 1000;
			} else {
				//取消勾选时做的事，arguments[1]是当前取消勾选的项
				this.sum = (item.after_tax_paid_salary * 1000 * -1 + this.sum * 1000) / 1000;
			}

			this.sums[5] = this.sum;
			this.showSum = false;
			this.$nextTick()
				.then(() => {
					this.showSum = true;
				})
		},
		
		//导表
		async ExportForm() {
			var temporary = [];
			this.condition.organize_ids.forEach(item => {
				temporary.push(item[item.length - 1]);
			})
			var organize_ids = "";
			temporary.forEach(item => {
				organize_ids += item + ",";
			})

			var url = 'DistributionSummary/getSummary';
			var record = {
				organizeIds:organize_ids,
				years_date: this.condition.years_date + '-01',
				applicant_id: this.$globals.user.staff_id,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					if ( data.length > 0) {
						this.$message.success("导表成功！文件下载中！");
						return data;
					} else {
						this.$message.success("没有可以导出的数据！");
						return null;
					}

				}
			}
		},

		//导入
		savefileUrl() {
			const url = this.$globals.http + "file/updateSalary";
			axios.post(url, {
				file_Route: this.fileurl,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;


				if (code === '200') {
					if (data === [] || data === '') {
						this.$message.success('导入成功！');
						this.dialogVisibledr = false;
					} else {
						this.$message.success('导入失败！');
						this.fileData = data;
						this.fileDatatitle = true;
						this.fileurl = '';
						// console.log(this.fileData)
					}

				} else {
					this.$message.warning("请求失败！请稍后重试");
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},

		handleSelectAll(selection) {
			this.sum = 0;
			if (selection.length == 0) {
				this.sums[5] = this.sum;
				this.showSum = false;
				this.$nextTick()
					.then(() => {
						this.showSum = true;
					})
			} else {
				selection.forEach(item => {
					const value = Number(item.paid_amount);
					if (!isNaN(value)) {
						this.sum = (this.sum * 1000 + value * 1000) / 1000;
					}
				});
			}
		},

		//子表没数据不展示折叠箭头
		tableRowClassName({
			row,
			rowIndex
		}) {
			if (row.detailsList.length == 0) {
				return 'row-expand-cover';
			} else {
				return '';
			}
		},
		//查询
		Find() {
			var temporary = [];
			this.condition.organize_ids.forEach(item => {
				temporary.push(item[item.length - 1]);
			})
			var organize_ids = "";
			temporary.forEach(item => {
				organize_ids += item + ",";
			})
			const url = this.$globals.http + "DistributionSummary/selectSummaryAll";
			axios.post(url, {
				page_num: this.page_num,
				page_size: this.page_size,
				organizeIds:organize_ids,
				years_date: this.condition.years_date + '-01',
				applicant_id: this.$globals.user.staff_id,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;
				if (code === '200') {
					this.tableData = data.list;
					this.total = data.total;
				} else {
					this.$message.warning("请求失败！请稍后重试");
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},
		//代发
		async examine(e) {
			var ids;
			var idsson;
			if (e === null || e === "" || e === undefined) {
				ids = this.ids;
				idsson = this.idsson;
			} else {
				ids = [e];
			}

			var url = "DistributionSummary/IssueOnBehalf";
			var record = {
				organize_ids: ids,
				years_date: this.condition.years_date + '-01',
				details_ids: idsson
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.$set(this.$refs.table.scope.row.detailsList);
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
		},
		//发放
		async grant(e) {
			var ids;
			var idsson;
			if (e === null || e === "" || e === undefined) {
				ids = this.ids;
				idsson = this.idsson;
			} else {
				ids = [e];
			}

			var url = "DistributionSummary/DistributionGrant";
			var record = {
				organize_ids: ids,
				years_date: this.condition.years_date + '-01',
				details_ids: idsson
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.trash();
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
		},
		//分页
		handleCurrentChange(val) {
			this.page_num = val
			this.Find();
		},

		getSummaries(param) {
			// const { columns, data } = param;
			// const sums = [];
			// columns.forEach((column, index) => {
			// 	if (index === 0) {
			// 		sums[index] = '合计';
			// 		return;
			// 	}
			// 	// if (column.property == "paid_amount"||column.property == "cash"||column.property == "bank_card") {
			// 	const values = data.map(item => Number(item[column.property]));
			// 	if (!values.every(value => isNaN(value))) {
			// 		sums[index] = values.reduce((prev, curr) => {
			// 			const value = Number(curr);
			// 			if (!isNaN(value)) {
			// 				return (prev * 1000 + curr * 1000) / 1000;
			// 			} else {
			// 				return prev;
			// 			}
			// 		}, 0);
			// 		sums[index] += ' 元';
			// 	} else {
			// 		sums[index] = 'N/A';
			// 	}
			// 	// }
			// });
			return this.sums;
		},
		//初始化组织架构及下面的人
		async organizeFind() {
			var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
				identification: "1",
				id: this.condition.project_id
			});
			this.organizeList = this.getTreeData(organizeList.data);
		},
		getTreeData(data) {
			// 循环遍历json数据
			for (var i = 0; i < data.length; i++) {

				if (data[i].organizeList.length < 1) {
					// children若为空数组，则将children设为undefined
					data[i].organizeList = undefined;
				} else {
					// children若不为空数组，则继续 递归调用 本方法
					this.getTreeData(data[i].organizeList);
				}
			}
			return data;
		}

	},
	async created() {
		this.organizeFind();
		// this.Find();
	}
}
</script>

<style scoped="scoped">
>>>.el-button:hover {
	background-color: #FFFFFF;
}

>>>.el-button:focus {
	background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #006E4B;
}

>>>.el-input__inner:focus {
	border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
	border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #006E4B;
	border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
	border-color: #006E4B;
}

>>>.row-expand-cover .el-table__expand-column .el-icon {
	visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// GzffHz.vue?7855cbb8